export default __webpack_public_path__ + "static/media/arkstream_capital.f9bfdd64.png";